import { axiosPut, del, get, post } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  checkCalendarCanBeDeletedFailed,
  checkCalendarCanBeDeletedSuccess,
  cloneCalendarFailed,
  cloneCalendarSuccess,
  createBookingFailed,
  createBookingSuccess,
  createBookingCalendarFailed,
  createBookingCalendarSuccess,
  createSubCalendarFailed,
  createSubCalendarSuccess,
  deleteCalendarFailed,
  deleteCalendarSuccess,
  deleteSubCalendarFailed,
  deleteSubCalendarSuccess,
  getAllCalendarsFailed,
  getAllCalendarsSuccess,
  getAllSubCalendarsFailed,
  getAllSubCalendarsSuccess,
  getBookingsFailed,
  getBookingsSuccess,
  getCalendarFailed,
  getBookingCalendarsFailed,
  getBookingCalendarsSuccess,
  getCalendarSuccess,
  getSubCalendarFailed,
  getSubCalendarsFailed,
  getSubCalendarsSuccess,
  getSubCalendarSuccess,
  hideCloneCalendarModal,
  hideCreateBookingModal,
  hideDeleteCalendarModal,
  hideDeleteSubCalendarModal,
  openCreateBookingWarningModal,
  openDeleteCalendarModal,
  updateBookingCalendarFailed,
  updateBookingCalendarSuccess,
  updateSubCalendarFailed,
  updateSubCalendarStatusFailed,
  updateSubCalendarStatusSuccess,
  updateSubCalendarSuccess,
  setBookingCheckoutSession,
  getSelectedBookingFailed,
  getSelectedBookingSuccess,
  cloneSubCalendarFailed,
  cloneSubCalendarSuccess,
  reorderCalendarSuccess,
  reorderSubCalendarsSuccess,
  connectOutlookFailed,
  disconnectCalendarFailed,
  disconnectCalendarSuccess,
  getOutlookCalendarsFailed,
  getOutlookCalendarsSuccess,
  syncOutlookCalendarsFailed,
  syncOutlookCalendarsSuccess,
  getSubCalendarReportsFailed,
  getSubCalendarReportsSuccess,
  getBookingDateReportsFailed,
  getBookingDateReportsSuccess,
  getCalendarGroupReportsFailed,
  getCalendarGroupReportsSuccess,
  getBookingStatusReportsFailed,
  getBookingStatusReportsSuccess,
  getUserBookingReportsFailed,
  getUserBookingReportsSuccess,
  getBookingReportsFailed,
  getBookingReportsSuccess,
  updateBookingFailed,
  updateBookingSuccess,
  cancelBookingFailed,
  cancelBookingSuccess,
  refundBookingSuccess,
  refundBookingFailed,
} from "./actions"
import {
  CHECK_CALENDAR_CAN_BE_DELETED,
  CLONE_CALENDAR,
  CREATE_BOOKING,
  CREATE_BOOKING_CALENDAR,
  CREATE_SUB_CALENDAR,
  DELETE_CALENDAR,
  DELETE_SUB_CALENDAR,
  GET_ALL_CALENDARS,
  GET_ALL_SUB_CALENDARS,
  GET_BOOKINGS,
  GET_CALENDAR,
  GET_BOOKING_CALENDARS,
  GET_SUB_CALENDAR,
  GET_SUB_CALENDARS,
  UPDATE_BOOKING_CALENDAR,
  UPDATE_SUB_CALENDAR,
  UPDATE_SUB_CALENDAR_STATUS,
  GET_SELECTED_BOOKING,
  CLONE_SUB_CALENDAR,
  REORDER_CALENDARS,
  REORDER_SUB_CALENDARS,
  CONNECT_OUTLOOK,
  DISCONNECT_CALENDAR,
  GET_OUTLOOK_CALENDARS,
  SYNC_OUTLOOK_CALENDARS,
  GET_SUB_CALENDAR_REPORTS,
  GET_BOOKING_DATE_REPORTS,
  GET_CALENDAR_GROUP_REPORTS,
  GET_BOOKING_STATUS_REPORTS,
  GET_USER_BOOKING_REPORTS,
  GET_BOOKING_REPORTS,
  UPDATE_BOOKING,
  CANCEL_BOOKING,
  REFUND_BOOKING,
} from "./actionTypes"

function* getBookingCalendars({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_URL, { params })
    yield put(getBookingCalendarsSuccess(response))
  } catch (error) {
    yield put(getBookingCalendarsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getBookings({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_URL, { params })
    yield put(getBookingsSuccess(response))
  } catch (error) {
    yield put(getBookingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getSubCalendars({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_TYPE_URL, { params })
    yield put(getSubCalendarsSuccess(response))
  } catch (error) {
    yield put(getSubCalendarsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateSubCalendarStatus({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.BOOKING_TYPE_URL}/${params?.id}`,
      params
    )
    yield put(updateSubCalendarStatusSuccess(params))
    showToast("success", "Sub Calendar Updated!", "Success")
  } catch (error) {
    yield put(updateSubCalendarStatusFailed(error))
    showToast("error", error, "Error")
  }
}

function* createBookingCalendar({ payload: params }) {
  try {
    const response = yield post(url.CALENDAR_URL, params)
    yield put(createBookingCalendarSuccess(response))
    showToast("success", "Calendar created!", "Success")
  } catch (error) {
    yield put(createBookingCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateBookingCalendar({ payload: params }) {
  try {
    const response = yield axiosPut(`${url.CALENDAR_URL}/${params?.id}`, params)
    yield put(updateBookingCalendarSuccess(response))
    showToast("success", "Calendar updated!", "Success")
  } catch (error) {
    yield put(updateBookingCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* getSubCalendar({ payload: params }) {
  try {
    const response = yield get(`/booking-type/${params?.id}`)
    yield put(getSubCalendarSuccess(response))
  } catch (error) {
    yield put(getSubCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAllCalendars({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_URL, { params })
    yield put(getAllCalendarsSuccess(response))
  } catch (error) {
    yield put(getAllCalendarsFailed(error))
    showToast("error", error, "Error")
  }
}

function* createBooking({ payload: params }) {
  try {
    const response = yield post(url.BOOKING_URL, params?.values)
    if (response?.checkout_session) {
      yield put(setBookingCheckoutSession(response))
      window.open(response?.checkout_session?.url)
    } else {
      if (params?.callback) {
        params?.callback()
      }
      yield put(hideCreateBookingModal())
      showToast("success", "Booking created!", "Success")
    }
    yield put(createBookingSuccess(response))
  } catch ({ response }) {
    yield put(
      createBookingFailed(
        response?.data?.error || "Something went wrong! Please try again!"
      )
    )
    yield put(openCreateBookingWarningModal())
  }
}

function* getAllSubCalendars({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_TYPE_URL, { params })
    yield put(getAllSubCalendarsSuccess(response))
  } catch (error) {
    yield put(getAllSubCalendarsFailed(error))
    showToast("error", error, "Error")
  }
}

function* createSubCalendar({ payload: params }) {
  try {
    const response = yield post(url.BOOKING_TYPE_URL, params)
    const createdSubCalendar = yield get(`/booking-type/${response?.id}`)
    yield put(createSubCalendarSuccess(createdSubCalendar))
    showToast("success", "Sub Calendar created!", "Success")
  } catch (error) {
    yield put(createSubCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* cloneCalendar({ payload: params }) {
  try {
    const response = yield post("/admin/calendar/clone", params?.values)
    if (params?.callback) {
      params?.callback()
    }
    yield put(cloneCalendarSuccess(response))
    showToast("success", "Calendar cloned!", "Success")
    yield put(hideCloneCalendarModal())
  } catch (error) {
    yield put(cloneCalendarFailed(error))
    showToast("error", error, "Error")
    yield put(hideCloneCalendarModal())
  }
}

function* deleteCalendar({ payload: params }) {
  try {
    const response = yield del(`/calendar/${params?.id}`)
    if (params?.callback) {
      params?.callback()
    }
    yield put(deleteCalendarSuccess(response))
    showToast("success", "Calendar deleted!", "Success")
    yield put(hideDeleteCalendarModal())
  } catch (error) {
    yield put(deleteCalendarFailed(error))
    showToast("error", error, "Error")
    yield put(hideDeleteCalendarModal())
  }
}

function* checkCalendarCanBeDeleted({ payload: params }) {
  try {
    const response = yield get("/admin/calendar/can-be-deleted", { params })
    yield put(checkCalendarCanBeDeletedSuccess(response?.can_delete || false))
  } catch (error) {
    yield put(checkCalendarCanBeDeletedFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCalendar({ payload: params }) {
  try {
    const response = yield get(`${url.CALENDAR_URL}/${params?.id}`)
    yield put(getCalendarSuccess(response))
  } catch (error) {
    yield put(getCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteSubCalendar({ payload: params }) {
  try {
    const response = yield del(`${url.BOOKING_TYPE_URL}/${params?.id}`)
    if (params?.callback) {
      params?.callback()
    }
    yield put(deleteSubCalendarSuccess(response))
    yield put(hideDeleteSubCalendarModal())
    showToast("success", "Sub Calendar deleted!", "Success")
  } catch (error) {
    yield put(deleteSubCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateSubCalendar({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.BOOKING_TYPE_URL}/${params?.id}`,
      params
    )
    const updatedSubCalendar = yield get(`/booking-type/${params?.id}`)
    yield put(updateSubCalendarSuccess(updatedSubCalendar))
    showToast("success", "Sub Calendar Updated!", "Success")
  } catch ({ response }) {
    yield put(updateSubCalendarFailed(response))
    showToast(
      "error",
      response?.data?.error?.max_seats_per_booking ||
        "Something went wrong! Please try again!",
      "Error"
    )
  }
}

function* getSelectedBooking({ payload: params }) {
  try {
    const response = yield get(`${url.BOOKING_URL}/${params?.id}`)
    yield put(getSelectedBookingSuccess(response))
  } catch (error) {
    yield put(getSelectedBookingFailed(error))
    showToast("error", error, "Error")
  }
}

function* cloneSubCalendar({ payload: params }) {
  try {
    const response = yield post(`admin/booking-type/${params?.id}/clone`)
    yield put(cloneSubCalendarSuccess(response))
    showToast("success", "Sub Calendar Cloned", "Success")
  } catch (error) {
    yield put(cloneSubCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* reorderCalendars({ payload: params }) {
  try {
    yield post("admin/calendars/order", params)
    yield put(reorderCalendarSuccess(params?.calendars))
  } catch (error) {
    showToast("error", error, "Error")
  }
}

function* reorderSubCalendars({ payload: params }) {
  try {
    yield post("admin/booking-types/order", params)
    yield put(reorderSubCalendarsSuccess(params?.booking_types))
  } catch (error) {
    showToast("error", error, "Error")
  }
}

function* connectOutlook({ payload: params }) {
  try {
    const response = yield get(
      `/admin/calendar/${params?.calendar_id}/connect-outlook`
    )
    if (response?.url) {
      window.location.replace(response?.url)
    }
  } catch ({ response }) {
    yield put(connectOutlookFailed("ERROR"))
  }
}

function* disconnectCalendar({ payload: params }) {
  try {
    const response = yield get(
      `/admin/calendar/${params?.calendar_id}/disconnect-external`,
      { params: { type: params?.type } }
    )
    if (params?.callback) {
      params?.callback()
    }
    yield put(disconnectCalendarSuccess(response))
    showToast("success", "Account disconnected!", "Success")
  } catch (error) {
    showToast("error", error, "Error")
    yield put(disconnectCalendarFailed(error))
  }
}

function* getOutlookCalendars({ payload: params }) {
  try {
    const response = yield get("/admin/external-calendars", { params })
    yield put(getOutlookCalendarsSuccess(response))
  } catch (error) {
    yield put(getOutlookCalendarsFailed(error))
    showToast("error", error, "Error")
  }
}

function* syncOutlookCalendars({ payload: params }) {
  try {
    const response = yield post(
      `/admin/calendar/${params?.values?.calendar_id}/sync-calendars`,
      params?.values
    )
    if (params?.callback) {
      params?.callback()
    }
    yield put(syncOutlookCalendarsSuccess(response))
    showToast("success", "Configuration saved", "Success")
  } catch (error) {
    yield put(syncOutlookCalendarsFailed(error))
    showToast("error", "Please try again", "Error")
  }
}

function* getSubCalendarReports({ payload: params }) {
  try {
    const response = yield get(url.SUB_CALENDAR_REPORTS_URL, { params })
    yield put(getSubCalendarReportsSuccess(response))
  } catch (error) {
    yield put(getSubCalendarReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getBookingDateReports({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_DATE_REPORTS_URL, { params })
    yield put(getBookingDateReportsSuccess(response))
  } catch (error) {
    yield put(getBookingDateReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCalendarGroupReports({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_GROUP_REPORTS_URL, { params })
    yield put(getCalendarGroupReportsSuccess(response))
  } catch (error) {
    yield put(getCalendarGroupReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getBookingStatusReports({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_STATUS_URL, { params })
    yield put(getBookingStatusReportsSuccess(response))
  } catch (error) {
    yield put(getBookingStatusReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getUserBookingReports({ payload: params }) {
  try {
    const response = yield get(url.USERS_BOOKING_URL, { params })
    yield put(getUserBookingReportsSuccess(response))
  } catch (error) {
    yield put(getUserBookingReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getBookingReports({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_REPORTS_URL, { params })
    yield put(getBookingReportsSuccess(response))
  } catch (error) {
    yield put(getBookingReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateBooking({ payload: params }) {
  try {
    const response = yield axiosPut(
      `/admin/booking/${params?.values?.id}`,
      params?.values
    )
    if (params?.callback) {
      params?.callback()
    }
    yield put(updateBookingSuccess(response))
    showToast("success", "Booking updated", "Success")
  } catch (error) {
    yield put(updateBookingFailed(error))
    showToast("error", error, "Error")
  }
}

function* cancelBooking({ payload: params }) {
  try {
    const response = yield post(
      `/booking/${params?.values?.booking_id}/cancel`,
      params?.values
    )
    if (params?.callback) {
      params?.callback()
    }
    showToast("success", "Booking has been cancelled", "Success")
    yield put(cancelBookingSuccess(response))
  } catch (error) {
    yield put(cancelBookingFailed(error))
    showToast("error", error, "Error")
  }
}

function* refundBooking({ payload: params }) {
  try {
    const response = yield post(
      `/admin/booking/${params?.values?.booking_id}/refund`,
      params?.values
    )
    if (params?.callback) {
      params?.callback()
    }
    showToast("success", "Payment refunded", "Success")
    yield put(refundBookingSuccess(response))
  } catch (error) {
    yield put(refundBookingFailed(error))
    showToast("error", error, "Error")
  }
}

function* bookingsFeatureSaga() {
  yield takeEvery(GET_BOOKING_CALENDARS, getBookingCalendars)
  yield takeEvery(GET_BOOKINGS, getBookings)
  yield takeEvery(GET_SUB_CALENDARS, getSubCalendars)
  yield takeEvery(UPDATE_SUB_CALENDAR_STATUS, updateSubCalendarStatus)
  yield takeEvery(CREATE_BOOKING_CALENDAR, createBookingCalendar)
  yield takeEvery(UPDATE_BOOKING_CALENDAR, updateBookingCalendar)
  yield takeEvery(GET_SUB_CALENDAR, getSubCalendar)
  yield takeEvery(GET_ALL_CALENDARS, getAllCalendars)
  yield takeEvery(CREATE_BOOKING, createBooking)
  yield takeEvery(GET_ALL_SUB_CALENDARS, getAllSubCalendars)
  yield takeEvery(CREATE_SUB_CALENDAR, createSubCalendar)
  yield takeEvery(CLONE_CALENDAR, cloneCalendar)
  yield takeEvery(DELETE_CALENDAR, deleteCalendar)
  yield takeEvery(CHECK_CALENDAR_CAN_BE_DELETED, checkCalendarCanBeDeleted)
  yield takeEvery(GET_CALENDAR, getCalendar)
  yield takeEvery(DELETE_SUB_CALENDAR, deleteSubCalendar)
  yield takeEvery(UPDATE_SUB_CALENDAR, updateSubCalendar)
  yield takeEvery(GET_SELECTED_BOOKING, getSelectedBooking)
  yield takeEvery(CLONE_SUB_CALENDAR, cloneSubCalendar)
  yield takeEvery(REORDER_CALENDARS, reorderCalendars)
  yield takeEvery(REORDER_SUB_CALENDARS, reorderSubCalendars)
  yield takeEvery(CONNECT_OUTLOOK, connectOutlook)
  yield takeEvery(DISCONNECT_CALENDAR, disconnectCalendar)
  yield takeEvery(GET_OUTLOOK_CALENDARS, getOutlookCalendars)
  yield takeEvery(SYNC_OUTLOOK_CALENDARS, syncOutlookCalendars)
  yield takeEvery(GET_SUB_CALENDAR_REPORTS, getSubCalendarReports)
  yield takeEvery(GET_BOOKING_DATE_REPORTS, getBookingDateReports)
  yield takeEvery(GET_CALENDAR_GROUP_REPORTS, getCalendarGroupReports)
  yield takeEvery(GET_BOOKING_STATUS_REPORTS, getBookingStatusReports)
  yield takeEvery(GET_USER_BOOKING_REPORTS, getUserBookingReports)
  yield takeEvery(GET_BOOKING_REPORTS, getBookingReports)
  yield takeEvery(UPDATE_BOOKING, updateBooking)
  yield takeEvery(CANCEL_BOOKING, cancelBooking)
  yield takeEvery(REFUND_BOOKING, refundBooking)
}

export default bookingsFeatureSaga
